module.exports = function(text, sortText) {
    return sortText && sortText.length ? text.replace(sortText, "<strong>" + sortText + "</strong>") : text;    
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/highlightSortText.js
// module id = 3
// module chunks = 0